import React, { useCallback } from 'react';
import { getClasses, parsePhoneNumber } from '@/utils';

import Input from '@/components/Input';
import { Location } from '@/models/gen/graphql';
import Table from '@/common/Table';

export type LocationsTableRowProps = {
  data: Location;
  isSelected: boolean;
  onSelect: (id: string) => void;
  onDoubleClick: () => void;
};

/**
 * A single data row in the locations table.
 * Receives its Location data and selection state as props.
 */
const LocationsTableRow = ({ data, isSelected, onSelect, onDoubleClick }: LocationsTableRowProps): React.JSX.Element => {
  const classes = getClasses(isSelected ? 'selected' : undefined);

  const handleSelectClick = useCallback((): void => onSelect(data.id), [onSelect, data.id]);

  return (
    <Table.Row className={classes} onDoubleClick={onDoubleClick}>
      <Table.Cell className="SELECT">
        <Input type="checkbox" name="SELECT_LOCATION" checked={isSelected} onChange={handleSelectClick} />
      </Table.Cell>
      <Table.Cell className="NAME alternate" data-placeholder="--">
        {data?.name}
      </Table.Cell>
      <Table.Cell className="CITY_NAME" data-placeholder="--">
        {data?.cityName}
      </Table.Cell>
      <Table.Cell className="STATE_CODE" data-placeholder="--">
        {data?.stateCode}
      </Table.Cell>
      <Table.Cell className="ZIP_CODE" data-placeholder="--">
        {data?.zipCode}
      </Table.Cell>
      <Table.Cell className="PHONE_NUMBER alternate" data-placeholder="--">
        {data?.phoneNumber ? parsePhoneNumber(data.phoneNumber, ' ') : undefined}
      </Table.Cell>
    </Table.Row>
  );
};

export default React.memo(LocationsTableRow);
